import React from "react";

const Footer = () => {
  return (
    <div className="flex justify-center h-16 items-center bg-orange-600">
      <span className="text-2xl text-white">Created by Abhishek Singh</span>
    </div>
  );
};

export default Footer;
